var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeskGetKm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 382,
    viewBox: "0 0 341 382",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.356 203.043C275.409 188.453 333.535 109.425 340.455 0V373.77C340.455 378.189 337.071 381.773 332.653 381.779C281.126 381.844 -1.27194 382.247 0.00431229 381.77C55.361 361.1 76.7558 361.101 141.801 320.979C158.932 310.412 186.276 291.626 208.98 269.914C237.972 242.188 261.279 211.226 266.356 203.043Z",
    fill: "#C1D4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskGetKm);
export default __webpack_public_path__ + "static/media/DeskGetKM.cde0ac23006db1520038d7ce5310c4c5.svg";
export { ForwardRef as ReactComponent };